<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="bibles"
            class="table"
            hide-default-footer            
        >
            <template #no-data>
                <span>{{ $t('indicators.indicators_list.no_records_found') }}</span>
            </template>
            <template #item.status="{ item }">
                <v-chip
                    :color="getReportStatusBadgeColor(item.status)"
                    text-color="white"
                    class="px-0"
                    label
                    small
                >
                    <span class="text-center status-chip">{{ getReportStatusTranslation(item.status) }}</span>
                </v-chip>
            </template>
            <template #item.actions="{ item }">
                <v-btn
                        class='btn-icon--primary btn-icon'
                    ><v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>            
        </v-data-table>                
    </div>
</template>

<script>
import {i18n} from "@/i18n";

export default {
    name: "IndicatorsDataOriginTable",    

    data () {
        return {
            headers: [
                { text: i18n.t('indicators.indicators_list.headers.origin'),
                    align: 'start',
                    value: 'origin',
                    sortable: false
                },
                { text: i18n.t('indicators.indicators_list.headers.name'),
                    align: 'start',
                    value: 'name',
                    sortable: false
                },                
                { text: i18n.t('indicators.indicators_list.headers.status'),
                    align: 'start',
                    value: 'status', 
                    sortable: false
                },
                { align: 'center',
                    value:'actions',
                    sortable: false
                }
            ],

            bibles: [                
                {
                    origin: "Biblia de grado",
                    name: "Biblia-Grado-2021",
                    status: "GENERATED"
                },
                {
                    origin: "Biblia de máster",
                    name: "Biblia-Master-2021",
                    status: "GENERATED"
                },
                {
                    origin: "Encuesta",
                    name: "Encuesta-2021",
                    status: "IN_REVIEW"
                },
                {
                    origin: "Indicador de abandono",
                    name: null,
                    status: "FAILED"
                },
            ],
        }
    },

    methods: {
        /**
         *
         * @param status
         * @returns {*}
         */
        getReportStatusBadgeColor(status) {
            let colorsByStatus = {                
                GENERATED: 'success',
                IN_REVIEW: 'warning',                
                FAILED: 'error'
            }

            return colorsByStatus[status] || '';
        },

        /**
         *
         * @param status
         * @returns {*}
         */
        getReportStatusTranslation(status) {
            return i18n.t(`reports.statuses.${status}`);
        },
    }
}
</script>

<style scoped>
    .status-chip {
        min-width: 90px;
    }
</style>
